// Prywatne pliki (dokumentacja, załączniki zgłoszeń) nie mają już publicznego URL-a.
// Wskazujemy na endpointy /download w backendzie, które po sprawdzeniu uprawnień
// przekierowują (302) na krótkotrwały presigned URL. Ta sama baza co klient API,
// żeby żądania <a>/<img> szły do backendu z ciasteczkiem auth (same-site).
const API_BASE = process.env.REACT_APP_API_URL || '';

export const documentationDownloadUrl = (documentationId: string) =>
  `${API_BASE}/api/documentation/${documentationId}/download`;

export const attachmentDownloadUrl = (ticketId: string, attachmentId: string) =>
  `${API_BASE}/api/tickets/${ticketId}/attachments/${attachmentId}/download`;
